module.exports = __webpack_public_path__ + "efe1f02ac406c9f34c6fe221bcfa6895.svg";